import { TimelineLite } from 'gsap';
import { random } from './helpers/random';
import { DEG_TO_RAD } from './gameConstants';

class AnimationDrawer {
  blinking(texture, duration = .2, scales = [1.5, .5, 1]) {
    return new TimelineLite()
      .to(texture, { duration, pixi: { scale: scales[0] } })
      .to(texture, { duration, pixi: { scale: scales[1] } })
      .to(texture, { duration, pixi: { scale: scales[2] } });
  }

  click(texture, duration = .1, scales = [.9,1]) {
    return new TimelineLite()
      .to(texture, { duration, pixi: { scale: scales[0] } })
      .to(texture, { duration, pixi: { scale: scales[1] } });
  }

  spin(texture, duration = .5) {
    return new TimelineLite()
      .to(texture, { duration, rotation: 25 * DEG_TO_RAD })
      .to(texture, { duration, rotation: 0 });
  }

  shake(texture, duration = .15, { x, y }) {
    let diff = 2;
    let stepCount = 50;
    return new Array(stepCount).fill(null).reduce((timelineLite, _, index) => {
      if (index < 5) {
        diff = 1;
      } else if (index < 17) {
        diff = 2;
      } else if (index < 28) {
        diff = 3;
      } else {
        diff = 4;
      }
      const xDeference = random(-diff, diff);
      const yDeference = random(-diff, diff);
      return timelineLite.to(texture, duration, { x: x + xDeference, y: y + yDeference });
    }, new TimelineLite());
  }
}

export const animationDrawer = new AnimationDrawer();
